/** Human-readable label for a portfolio file URL (filename, not host/uuid). */
export function portfolioFileLabel(fileUrl: string): string {
  if (!fileUrl) {
    return 'Document';
  }

  const withoutQuery = fileUrl.split('?')[0].split('#')[0];
  const segment = decodeURIComponent(withoutQuery.split('/').filter(Boolean).pop() || '');

  if (!segment) {
    return 'Document';
  }

  return segment;
}
